exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ErrorPage_wrapper_25g8 {\n  grid-area: 2 / 1 / 3 / 2;\n}\n.ErrorPage_image-wrapper_FAc3 {\n  margin-bottom: 36px;\n\n  width: 114px;\n  height: 109px;\n}\n.ErrorPage_image_2dR8 {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.ErrorPage_title_2u-y {\n  margin-bottom: 16px;\n}\n.ErrorPage_description_3qGr {\n  margin-bottom: 24px;\n}\n@media (min-width: 768px) {\n  .ErrorPage_description_3qGr {\n    margin-bottom: 36px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "ErrorPage_wrapper_25g8",
	"image-wrapper": "ErrorPage_image-wrapper_FAc3",
	"image": "ErrorPage_image_2dR8",
	"title": "ErrorPage_title_2u-y",
	"description": "ErrorPage_description_3qGr"
};